<template>
  <Card  :headerStyle="{background: '#d4d5d5'}" class="am-margin-bottom-sm cart" dis-hover >
    <h2 slot="title" class="am-g-collapse am-cf">
        <div class="am-fl">购物车 </div>
        <div class="am-fr am-text-right am-u-sm-5">
          <div class="am-u-sm-12">
            <span>{{store.storeName}}</span>
            <span class="am-padding-horizontal-xs">|</span>
            <span v-if="orderType === 2">{{store.waitTime}}分钟</span>
            <span v-else>{{store.waitTime}}分钟</span>
          </div>
          <div class="am-u-sm-12 am-text-truncate am-font-w-n am-padding-top-xs" :title="store.businessTimes | strTime" >
            ({{store.businessTimes | strTime}})
          </div>
        </div>
    </h2>
    <div>
    </div>
    <div class="cart-content">
      <div class="cart-title-bar am-margin-bottom-xs am-g-collapse am-g" >
        <div class="am-u-md-4 ">餐品</div>
        <div class="am-u-md-3">数量x单价</div>
        <div class="am-u-md-2">总价</div>
        <div class="am-u-md-3">操作</div>
      </div>
      <template >
        <div class="cart-product-list am-g-collapse am-g" >
          <!--购买的商品-->
          <ul   class=" am-g-collapse am-g ">
            <li v-for="(item, index) in products" :key="item._key+index" class="am-u-sm-12 am-margin-bottom-xs">
              <div class="am-u-md-4 ">
                <div class="am-text-truncate" :title="item.name">{{item.name}}</div>
              </div>
              <div class="am-u-md-3">
                <div class="am-fl">
                  <section>
                    <div class="din">
                      <template v-if="item.readonly">
                        <input autocomplete="off" spellcheck="false" type="text" placeholder=""  class="am-input am-input-small" readonly :value="item.num" style="width: 50px" >
                      </template>
                      <template v-else>
                        <input autocomplete="off" spellcheck="false" type="text" placeholder=""
                              class="am-input am-input-small"
                              v-model="item.num" style="width: 50px"
                              @blur="changeProductDynamicMax(item)" :maxlength="20"  >
                      </template>
                    </div>
                    <div class=" din" style="padding-left: 5px;">
                      <span>x</span>
                      <span class="prefix-price-unit">{{currency}}{{item.pricing || item.price | formatPrice(true)}}</span>
                    </div>
                  </section>
                  <div class="prefix-price-unit desc ">{{ item.originInfo }}</div>
                </div>
              </div>
              <div class="am-u-md-2" >
                <span class="prefix-price-unit am-color-price">{{currency}}{{item.totalProductPrice | formatPrice(true)}}</span>
              </div>
              <div class="am-u-md-3 am-g-collapse cart-product-action" >
                <div class="am-u-sm-4 am-fr"  v-if="!item.readonly" style="margin-right: 50px;">
                  <a href="javascript:void(0)" @click="removeProduct(item)">
                    删除
                  </a>
                </div>
                <!-- <div class="am-u-sm-4 am-fr"  >
                  <a href="javascript:void(0)" @click="switchRemark(item)">
                    备注
                  </a>
                </div> -->
                <div class="am-u-sm-4 am-fr"  v-if="!item.readonly">
                  <a href="javascript:void(0)"  v-if="item.isChange" @click="showProduct(item)">
                    修改
                  </a>
                </div>
              </div>
              <div class="am-u-md-12 " v-if="item._remarkVisible">
                <div class="cart-product-remark am-padding-xs am-cf">
                  <div class="am-u-md-9">
                    <Input type="text"  size="small" v-model="item._remark" placeholder="请输入餐品备注"  clearable/>
                  </div>
                </div>
              </div>
            </li>
            <!-- 容错餐品显示 -->
            <li v-for="(item, index) in outMenuProducts" :key="index" class="am-u-sm-12 am-margin-bottom-xs">
              <div class="am-u-md-4 ">
                <div class="am-text-truncate" :title="item.name">{{item.name}}</div>
              </div>
              <div class="am-u-md-3">
                <section>
                    <div class="din">
                      <template v-if="item.readonly">
                        <input autocomplete="off" spellcheck="false" type="text" placeholder=""  class="am-input am-input-small" readonly :value="item.num" style="width: 50px" >
                      </template>
                      <template v-else>
                        <input autocomplete="off" spellcheck="false" type="text" placeholder=""
                              class="am-input am-input-small"
                              v-model="item.num" style="width: 50px"
                              @blur="changeOutMenuProductDynamicMax(item)" :maxlength="20"  >
                      </template>
                    </div>
                    <div class=" din" style="padding-left: 5px;">
                      <span>x</span>
                      <span class="prefix-price-unit">{{currency}}{{item.pricing || item.price | formatPrice(true)}}</span>
                    </div>
                  </section>
                  <div class="prefix-price-unit desc ">{{ item.originInfo }}</div>
              </div>
              <div class="am-u-md-2" >
                <span class="prefix-price-unit am-color-price">{{currency}}{{item.totalProductPrice | formatPrice(true)}}</span>
              </div>
              <div class="am-u-md-3 am-g-collapse cart-product-action" >
                <div class="am-u-sm-4 am-fr"  v-if="!item.readonly" style="margin-right: 50px;">
                  <a href="javascript:void(0)" @click="removeOutMenuProduct(item, index)">
                    删除
                  </a>
                </div>
                <!-- <div class="am-u-sm-4 am-fr"  >
                  <a href="javascript:void(0)" @click="switchOutMenuRemark(item)">
                    备注
                  </a>
                </div> -->
                <div class="am-u-sm-4 am-fr"  >
                  <a href="javascript:void(0)"   @click="checkProduct(item)">
                    查看
                  </a>
                </div>
              </div>
              <div class="am-u-md-12 " v-if="item._remarkVisible">
                <div class="cart-product-remark am-padding-xs am-cf">
                  <div class="am-u-md-9">
                    <Input type="text"  size="small" v-model="item._remark" placeholder="请输入餐品备注"  clearable/>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <!--赠送产品-->
          <ul  class="am-g-collapse am-g ">
            <li class="am-u-sm-12 am-margin-bottom-xs" v-for="(item, key) in giveProducts" :key="key">
              <div class="am-u-md-4" >{{item.content}}</div>
              <div class="am-u-md-3 am-u-end" >{{item.num ? item.num + '份' : ''}}</div>
              <div class="am-u-md-2 am-u-end" >{{currency}}{{item.totalPrice}}</div>
            </li>
            <li v-if="preDeliveryPrice !== 0" class="am-u-sm-12 am-margin-bottom-xs">
              <span>减免配送费：</span>
              <span class="prefix-price-unit am-color-price">{{currency}}{{preDeliveryPrice}}</span>
            </li>
          </ul>
        </div>
        <div class="cart-total am-padding-vertical-xs am-g-collapse am-g " style="font-weight: bold">
          <div class="am-u-md-4 am-text-center">小计</div>
          <div class="am-u-md-3 am-text-truncate" :title="numTotal + '份'">{{numTotal}}份</div>
          <div class="am-u-md-2 am-u-end">{{productFee | formatPrice}}</div>
        </div>
      </template>
      <div class="cart-other-price">
        <p >
          <span>配送费：</span>
          <span class="prefix-price-unit am-color-price">{{currency}}{{orderData.deliveryFee | formatPrice}}</span>
          <span class="prefix-price-unit desc am-margin-left-10">原订单配送费{{currency}}{{orderData.deliveryFee | formatPrice}}</span>
        </p>
        <p>
          <span>餐盒费：</span>
          {{currency}}
          <Input class="" style="width: 88px" type="number" v-model.trim="finalMealFee" @on-blur="blurFinalMealFee" />
          <!-- <span class="prefix-price-unit am-color-price">{{currency}}{{mealFee | formatPrice}}</span> -->
          <span class="prefix-price-unit desc am-margin-left-10">原订单餐盒费{{orderData.mealFee | formatPrice}}</span>
        </p>
        <div class="cart-order-claim" v-if="isOrderClaim">
          <p>
            <span>未达起送条件：</span>
            <template v-if="store.deliveryType === 2">
              <span class="prefix-price-unit am-color-price">{{currency}}{{store.reachFee | formatPrice}}起送</span>
            </template>
            <template v-else>
              <span class="prefix-price-unit am-color-price">{{currency}}{{store.reachPart | formatPrice}}份起送</span>
            </template>
          </p>
        </div>
      </div>
      <div class="cart-price-count am-padding-top-xs">
        <span>合计：</span>
        <span class="prefix-price-unit am-color-price">{{currency}}{{total | formatPrice}}</span>
        <span>(不含优惠)</span>
        <span class="prefix-price-unit desc am-margin-left-10">原订单合计{{currency}}{{originOrderTotal | formatPrice}}</span>
      </div>
    </div>
  </Card>
</template>

<script>
  import {
    getAdditionalStockMaxNum,
    getRefIdMap,
    calculateStockObjMerge,
    getComboStockMaxNum
  } from '@/utils/productAction';
  import { mapState } from 'vuex';
  import { each, formatPrice, deepClone } from '@/utils/assist';
  import { action } from '@/utils/productAction';
  import amendHelp from '@os-plugins/utils/amendHelp.js';
  import Card from '@/components/Card/index';
  import Input from '@/components/Input/index';
  import utils from '@os-plugins/util.js';

const computePrice = (price)=> utils.computePrice(price,2);
  export default {
    inject: ['products', 'productsUseMaterialStock', 'productsRefIdMap', 'productsUseNum'],
    props: {
      deliveryFee: {
        type: Number
      }
    },
    created() {
    },
    data() {
        return {
          currency: window.currency,
          outMenuProducts: [],
          finalMealFee: 0,
        }
    },
    filters: {
      formatPrice,
      strTime (list, s = ',') {
        let str = '';
        if (Array.isArray(list)) {
          let times = list.map(item => {
            return `${item.beginTime}-${item.endTime}`;
          });
          str += times.join(s);
        }
        return str
      }
    },
    computed: {
      originOrderTotal() {
        return formatPrice(this.orderData.totalPrice);
        // return formatPrice(this.orderData.totalPrice + this.orderData.productPrePrice + this.orderData.deliveryPrePrice);
      },
      isOrderClaim() {
        let {store, cart, orderType } = this,
          state = store.deliveryType === 2 ? cart.fee.products >= store.reachFee : cart.count.total >= store.reachPart;
        // 是否到达订单要求 0符合 其他不符合
        return orderType === 2 || orderType ===3 ? false:state ? 0 : store.deliveryType
      },
      fee () {
        return this.cart.fee
      },
      productFee() {
        let fee = this.cart.fee.products;
        // fee += amendHelp.countProductFee(this.outMenuProducts);
        return fee;
      },
      numTotal () { // 餐品总数量
        let total = 0;
        each(this.products, (product) => {
          total += product.oldNum * 1;
        });
        each(this.outMenuProducts, (product) => {
          total += product.num * 1;
        });
        return total || 0;
      },
      total () {
        let totalPrice = formatPrice(this.productFee + this.mealFee + this.delivery)
        return totalPrice;
      },
      mealFee() {
        let fee = this.cart.mealFeeAmendShow;
        // fee += amendHelp.countMealFee(this.outMenuProducts);
        return fee;
      },
      delivery () { // 配送费
        return this.deliveryFee
      },
      ...mapState({
        cart: state => state.booking.cart,
        giveProducts: state => state.booking.cart.giveProducts,
        store: state => state.booking.store.data,
        promotionsList: state => state.booking.preferential.list, // 选中优惠活动
        orderData: state => state.booking.preferential.orderData, // 原订单数据
        orderType: state => state.booking.user.sendType,
        preDeliveryPrice: state => state.booking.preferential.preDeliveryPrice, // 优惠卡
        accuracy : state => state.booking.user.oprInfo.accuracy,
        cartMealFee: state => state.booking.cart.fee.mealFee,
      })
    },
    watch: {
      cartMealFee(n) {
        this.finalMealFee = n;
      },
    },  
    mounted() {
      let arr = this.cloneArr(this.cart.outMenuProducts);
      this.outMenuProducts.push(...arr)
    },
    methods: {
      handleAction: action,
      blurFinalMealFee(e) {
        if(!e.target.value) {
          this.finalMealFee = 0
        }
        this.finalMealFee = formatPrice(this.finalMealFee)
        this.$store.commit('booking/cart/updateFee', {mealFee: this.finalMealFee, });
      },
      cloneArr(list) {
        let arr = [];
        for (let index = 0; index <list.length; index++) {
          let item = list[index];
          let itemClone = deepClone(item);
          arr.push(itemClone);
        }
        return arr;
      },
      updateOutMenuPros() {
        let arr = this.cloneArr(this.outMenuProducts);
        this.$emit('outMenuProductsChange', arr)
        this.$store.commit('booking/cart/updateOutMenuPros', arr);
      },
      isProductAddition(item, productsUseMaterialStock, productsRefIdMap, oldNum) { // 判断特殊要求是否满足
        let {stockObj, refIdObj, num} = item,
          stockMax,
          maxNum,
          status = true;
        if (stockObj.len) {
          if (refIdObj.len) {
            productsUseMaterialStock = {...productsUseMaterialStock, ...getRefIdMap({...productsRefIdMap, ...refIdObj}, productsUseMaterialStock)};
          }
          stockObj = calculateStockObjMerge(stockObj, productsUseMaterialStock);
          stockMax = getAdditionalStockMaxNum(item, stockObj, 0).stockMax;
          if (stockMax === 0) {
            maxNum = oldNum;
            status = false;
          }
          if ((num - oldNum) > stockMax) {
            maxNum = stockMax + oldNum;
            status = false;
          }
        }
        return {status, maxNum, num}
      },
      isProductCombo(item, productsUseMaterialStock, productsRefIdMap, oldNum, productsUseNum) {  // 判断套餐是否满足
        let {productMaterialStock, productStockObj, num, productRefIds} = item,
          stockMax,
          maxNum,
          status = true;
        if (productMaterialStock.len || productStockObj.len) {
          // 餐品库存
          if (productStockObj.len) {
            // 剩下当前的餐品库存
            productStockObj = calculateStockObjMerge(productStockObj, productsUseNum, '-');
          }
          if (productRefIds.len) {
            productsUseMaterialStock = {...productsUseMaterialStock, ...getRefIdMap({...productsRefIdMap, ...productRefIds}, productsUseMaterialStock)}
          }
          if (productMaterialStock.len) {
            // 合并公共加料
            productMaterialStock = calculateStockObjMerge(productMaterialStock, productsUseMaterialStock);
          }
          stockMax = getComboStockMaxNum(item, productMaterialStock, productStockObj);
          if (stockMax === 0) {
            maxNum = oldNum;
            status = false;
          }
          if ((num - oldNum) > stockMax) {
            maxNum = stockMax + oldNum;
            status = false;
          }
        }
        return {status, maxNum, num}
      },
      changeOutMenuProductDynamicMax(item) {
        item.num = Number(item.num);
        let oldNum = item.oldNum,
        num = item.num * 1;
        if (num <= 0 || oldNum === num || isNaN(num)) {
          return item.num = oldNum;
        }

        item.oldNum = num;

        item.totalProductPrice = computePrice(item.num * item.price);
        // 内部的数量也要一起修改
        if(item.listRequirement) {
          item.listRequirement.map(req => req.num = item.num)
        }
        if(item.groups) {
          item.groups.map(req => req.num = item.num)
        }
        this.updateOutMenuPros();
        this.$store.dispatch('booking/cart/updateCommon'); //更新购物车
      },
      changeProductDynamicMax(item) { // 餐品数量改变
        console.log('餐品数量改变', item.num)
        let {productsUseMaterialStock, productsRefIdMap, productsUseNum} = this, {_key, type, oldNum, uid} = item,
          num = item.num * 1,
          products = this.cart.products,
          product = products[_key],
          arg = [deepClone(item), productsUseMaterialStock, productsRefIdMap, oldNum],
          maxNum = product.stockNum;
          // product.pid = item.pid = uid
        if (num <= 0 || oldNum === num || isNaN(num)) {
          return item.num = oldNum
        }
        if (oldNum > num) {
          return this.changeProductNum(item)
        }
        // 基本库存是否满足
        if (product.hasStock) {
          let cartNum = (productsUseNum[uid] || 0) - oldNum,
            total = cartNum + num;
          if (total > maxNum) {
            this.$Modal.error({title: '提示', content: `库存不足，当前只能最多添加${maxNum - cartNum}份`});
            return item.num = oldNum;
          }
        }
        // 加料库存是否满足
        if (type === 2 || product.isRequirement) {
          let o = type === 1 ? this.isProductAddition(...arg) : this.isProductCombo(...arg, productsUseNum);
          if (!o.status) {
            this.$Modal.error({title: '提示', content: `当前类型库存最多只能添加${o.maxNum}份`});
            return item.num = oldNum;
          }
        }
        this.changeProductNum(item);
      },
      changeProductNum (product) {
        //plu addition combo 修改产品数量
        product.num = product.num*1;
        this.handleAction(product, {
          plu(product) {
            // 单品
            this.$store.dispatch('booking/cart/changProductItem', {oldObj: product, type: 'set', obj: product})
          },
          addition(product) {
            // 特殊要求
            this.$emit('saveAdditional', product)
          },
          combo(product) {
            // 套餐
            this.$emit('saveCombo', product)
          }
        })
      },
      switchRemark (item) { //切换备注
        item._remarkVisible = !item._remarkVisible
      },
      switchOutMenuRemark (item) { //切换备注
        item._remarkVisible = !item._remarkVisible
      },
      showProduct (product) { // 显示餐品
        let {isRequirement, type, _key} = product;
        switch (type) {
          case 1:
            if (isRequirement) {
              this.$emit('initAdditional', {_key, action: 'change', _index: product._index})
            }
            break;
          case 2:
            this.$emit('getProductGroup', {_key, action: 'change', _index: product._index})
        }
      },
      checkProduct (product) { // 查看餐品
        this.$emit('checkProduct', product)
      },
      removeProduct(item) { // 删除餐品
        let {_key, uid, type, isRequirement} = item,
          products = this.cart.products,
          num = item.num * 1,
          cartNum = this.productsUseNum[uid],
          product = products[_key];
        if (type === 1 && !isRequirement || (num === cartNum)) {
          this.$store.dispatch('booking/cart/doMinus', {_key, num: 0});
        } else {
          let fnName = 'saveCombo';
          if (product.type === 1) fnName = 'saveAdditional';
          this.$emit(fnName, {...product, num: 0})
        }
      },
      removeOutMenuProduct(item, idx) { // 删除餐品
        this.outMenuProducts.splice(idx, 1);
        this.updateOutMenuPros()
        this.$store.dispatch('booking/cart/updateCommon'); //更新购物车
        // let {_key, uid, type, isRequirement} = item,
        //   products = this.cart.products,
        //   num = item.num * 1,
        //   cartNum = this.productsUseNum[uid],
        //   product = products[_key];
        // if (type === 1 && !isRequirement || (num === cartNum)) {
        //   this.$store.dispatch('booking/cart/doMinus', {_key, num: 0});
        // } else {
        //   let fnName = 'saveCombo';
        //   if (product.type === 1) fnName = 'saveAdditional';
        //   this.$emit(fnName, {...product, num: 0})
        // }
      },
    },
    components: {
      Card,
      Input
    },
    destroyed() {
    }
  }
</script>

<style  lang="less" scoped>
  .am-font-w-n {
    font-weight: normal;
  }
  // Color
  @link-color             : #2D8cF0;
  @link-hover-color       : tint(@link-color, 20%);
  @link-active-color      : shade(@link-color, 5%);
  @css-prefix: '';
  @cart-prefix-cls: ~"@{css-prefix}cart";
  .@{cart-prefix-cls} {
    .@{cart-prefix-cls}-title-bar {
      font-weight: 600;
    }
    .cart-product-action a{
      color: @link-color
    }
    .@{cart-prefix-cls}-product-action {
      color: fade(#2d8cf0, 75);
      a:hover{
        color: @link-hover-color
      }
      .hide {
        visibility: hidden;
      }
    }
    .@{cart-prefix-cls}-product-remark {
    }
    .@{cart-prefix-cls}-total {
      border-top: 1px solid #999;
    }
    .@{cart-prefix-cls}-other-price {
      position: relative;
      line-height: 24px
    }
    .@{cart-prefix-cls}-price-count {
      color: #f47e5a;
      font-size: 16px;
    }
    .@{cart-prefix-cls}-order-claim {
      position: absolute;
      right: 0;
      color: red;
      top: 50%;
      transform: translateY(-50%);
    }
  }

</style>



// WEBPACK FOOTER //
// components/pages/order/Cart/CartNew.vue